import {createAction} from '@reduxjs/toolkit';
import {ICommonCacheActionType} from '../Common.actions';
import {FileMetadata} from '../../types/models/files/FileMetadata';


export const FILE_CACHE: ICommonCacheActionType = {
  ADD: 'fileCache/add',
  UPDATE: 'fileCache/updated',
  MERGE_ITEMS: 'fileCache/merge',
  ERROR: 'fileCache/error',
  REMOVE: 'fileCache/remove'
};

export const fileCacheAdd = createAction<string[]>(FILE_CACHE.ADD);
export const fileCacheUpdate = createAction<string[]>(FILE_CACHE.UPDATE);
export const fileCacheMerge = createAction<FileMetadata[]>(FILE_CACHE.MERGE_ITEMS);
export const fileCacheError = createAction<string>(FILE_CACHE.ERROR);
export const fileCacheRemove = createAction<string>(FILE_CACHE.REMOVE);
